import type { User } from "schemas/generated/user";

import { getAgentDashboardPath } from "replo-utils/lib/dashboardRoutes";

type AgentLandingUser = Pick<
  User,
  | "defaultProjectId"
  | "defaultProjectHostingType"
  | "defaultProjectAgentEnabledAt"
>;

// The default project itself must be agent-enabled — the primary workspace's
// type can disagree for multi-workspace users (REPL-30166).
export function getAgentLandingPath(
  user: AgentLandingUser | null | undefined,
): string | null {
  if (
    user?.defaultProjectId &&
    user.defaultProjectHostingType === "replo" &&
    user.defaultProjectAgentEnabledAt
  ) {
    return getAgentDashboardPath({ projectId: user.defaultProjectId });
  }
  return null;
}

// "/" keeps non-agent logins on the legacy root router, exactly as before.
export function getPostLoginLandingPath(
  user: AgentLandingUser | null | undefined,
): string {
  return getAgentLandingPath(user) ?? "/";
}
